import { Component, Input, OnInit, Output, EventEmitter, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { faExclamationCircle, faUnlockAlt, faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-new-input-field',
  templateUrl: `new-input-field.component.html`,
  styleUrls: ['../common.scss'],
})

export class NewInputFieldComponent implements OnInit, OnDestroy {
  error = false;
  // previousStatus: string;
  icons = {
    faUnlockAlt: faUnlockAlt,
    faExclamationCircle: faExclamationCircle,
    faEnvelope: faEnvelope
  };
  public onAnimationStart: (event: AnimationEvent) => void;
  public autofillState: { start: boolean; cancel: boolean } = {start: false, cancel: false};
  private unsubscribe: Subject<void> = new Subject();

  @Input() type: string = 'text';
  @Input() label: string;
  @Input() errorLabel: string;
  @Input() control: FormControl;
  @Input() maskName: string;
  @Input() leadingIcon: string;
  @Input() trailingIcon: string;
  @Input() isReseting: boolean;
  @Input() matDatepicker: any;
  @Input() dataEncryptedName: string;
  @Input() onlyNumber: boolean;
  @Input() disabled: boolean;
  @Input() checkAutofill: boolean = false;

  @Output() change: EventEmitter<HTMLInputElement> = new EventEmitter();
  @Output() setIsReseting: EventEmitter<boolean> = new EventEmitter();

  @ViewChild('input') input: ElementRef;

  ngOnInit() {
    this.onAnimationStart = ({target, animationName}) => {
      if (animationName === 'onAutoFillStart') {
        this.autofillState = {...this.autofillState, start: true};
        this.input.nativeElement.removeEventListener('animationstart', this.onAnimationStart);
      } else if (animationName === 'onAutoFillCancel') {
        this.autofillState = {...this.autofillState, cancel: true};
      }
    };
    this.input.nativeElement.addEventListener('animationstart', this.onAnimationStart);
  }

  handleChange(event) {
    this.change.emit(event);
  }

  get mask() {
    switch (this.maskName) {
      case 'cardNumMask':
        return [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
      case 'expDateMask':
        return [/\d/, /\d/, '/', /\d/, /\d/];
      case 'cvcMask':
        return [/\d/, /\d/, /\d/];
      case 'regNumberMask':
        return [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      case 'dateMask':
        return [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
      default:
        return false;
    }
  }

  get inputStyles() {
    return this.leadingIcon ? {paddingLeft: '34px'} : {};
  }

  get classes() {
    let classes = '';
    if (this.leadingIcon) {
      classes += 'leading-icon ';
    }
    if (this.disabled) {
      classes += 'disabled ';
    }
    return classes;
  }

  ngOnDestroy() {
    this.input.nativeElement.removeEventListener('animationstart', this.onAnimationStart);
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/form-fields/new-input-field/new-input-field.component.ts